<template>
  <div>
    <Dropdown ref="dropdown">
      <template #button="{ open }">
        <BaseButton success @click="open"> Sync </BaseButton>
      </template>

      <div
        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div class="py-1">
          <WoocommerceApiServiceManagerItem
            v-for="woocommerceApiService in woocommerceApiServices"
            :key="woocommerceApiService.id"
            :woocommerce-api-service="woocommerceApiService"
          />
        </div>
      </div>
    </Dropdown>
  </div>
</template>

<script>
import WoocommerceApiServiceManagerItem from './woocommerce-api-service-manager-item.vue';

export default {
  components: {
    WoocommerceApiServiceManagerItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    woocommerceApiServices: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
